import { Section } from "@ua/web-sdk/lib/remote-data/preference-center"
import * as React from "react"

type Props = {
  section: Section
}

const LabeledSectionBreak: React.FC<Props> = ({ section }) => {
  return (
    <div className="labeled-section-break">
      {section.display?.name ?? section.id}
    </div>
  )
}

export default LabeledSectionBreak
